import { useAuth } from "@dutyon/apis";
import { Alert, Button, Container, LoadingOverlay, Paper, Stack, Text } from "@dutyon/ui-kit";
import { ShieldAlert } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function DutyAutoGenerationGuard({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const { user, activeNurse, isFetching } = useAuth();

  if (isFetching && !user) {
    return (
      <Container py="xl">
        <Paper h={180} pos="relative">
          <LoadingOverlay visible />
        </Paper>
      </Container>
    );
  }

  const isManager = activeNurse?.role === "HOSPITAL_ADMIN" || activeNurse?.role === "TEAM_ADMIN";
  const isCompanyEnabled = Boolean(activeNurse?.company?.dutyAutoGenerationEnabled);
  if (!isManager || !isCompanyEnabled) {
    return (
      <Container py="xl" size="sm">
        <Alert icon={<ShieldAlert size={18} />} color="orange" title="접근할 수 없는 기능입니다">
          <Stack gap="sm">
            <Text size="sm">
              Duty 자동 생성 기능이 활성화된 병원의 관리자(병원 관리자 또는 팀 관리자)만 사용할 수
              있습니다. 최고 관리자에게 소속 병원의 기능 활성화를 요청해 주세요.
            </Text>
            <Button variant="light" color="orange" onClick={() => navigate("/duty-requests")}>
              Duty 생성 요청으로 돌아가기
            </Button>
          </Stack>
        </Alert>
      </Container>
    );
  }

  return <>{children}</>;
}
